export default "__VITE_PUBLIC_ASSET__2765d8a1__"